import {create} from 'zustand';
import {devtools} from 'zustand/middleware';
import {ClientProfile} from '@/api/dto/client-profile';

export type ClientState = {
  currentClient: ClientProfile | null;
  setCurrentClient: (val: ClientProfile | null) => void;
}

export const useClientStore = create<ClientState>()(
  devtools(
    (set) => ({
      currentClient: null,
      setCurrentClient: (val: ClientProfile | null) => set({ currentClient: val }),
    }),
    { name: 'clientStore', enabled: ['local', 'dev', 'qa'].includes(process.env.REACT_APP_ENV || 'prod')},
  ),
);
